import React, {useState} from "react";
import { Link } from "react-router-dom";
import logoDecor1 from "../images/logo-graphic-bottom.svg";
import logoDecor2 from "../images/logo-graphic-top.svg";
import logo from "../images/volas-logo-vertical.svg";
import RedButton from "./Buttons/RedButton";
import { RedBtnImg } from "../types/Button";
import {RequestInviteButton} from "./Buttons/RequestInviteButton";
import {useModalData} from "./Modals/hooks/useModalData";
import {ModalOptions} from "../types/Modal";

const IsInvited = () => {
  return (
    <div className="text-volas-yellow text-center mt-6 text-xs">
      Invitation Sent! Thanks for your interest in Volas.
    </div>
  )
}

const LandingPage = () => {
  const [modalIsOpen, setIsOpen] = useState(false);
  const [isInvited, setIsInvited] = useState(false);
  const modalData = {
    modalIsOpen,
    setIsOpen,
    childModal: ModalOptions.HompageInviteRequest,
    childModalProps: {
      onClose: () => setIsOpen(false),
      onSuccess: () => {
        setIsOpen(false);
        setIsInvited(true);
      }
    },
  };

  useModalData(modalData);

  return (
    <div className="h-screen w-screen bg-logo-grey absolute flex flex-col justify-evenly items-center">
      <img className="logo-decor h-1/5 fixed top-0" src={logoDecor2} alt="" />
      <div className="fixed -translate-y-1/2 object-contain max-h-auto bg-logo-grey w-auto flex flex-col items-center justify-center">
        <img className="max-w-160 h-auto md:w-1/2" src={logo} alt="" />
        <h2 className="text-white text-xl md:text-2xl font-light py-4 md:py-8 text-center">
          The digital standard in aviation.
        </h2>
        <Link to="/login" className="flex justify-center">
          <RedButton
            onClickEvent={null}
            styles="self-center mt-6 md:mt-0 w-44 px-3 py-2 md:py-3 font-semibold text-xxs md:text-xs"
            title="LOG IN"
            img={RedBtnImg.Arrow}
          />
        </Link>
        {isInvited ? <IsInvited /> :<RequestInviteButton
          onClick={() => setIsOpen(true)}
          title="REQUEST AN INVITE"
        />}
      </div>
      <img className="logo-decor h-1/5 fixed bottom-0" src={logoDecor1} alt="" />
    </div>
  );
};

export default LandingPage;
